import { createContext } from '@lit/context'

/**
 * Registry the Card provides to its composed parts so they can announce their
 * presence without the Card scanning consumer-owned DOM.
 */
export interface CardPartRegistry {
  add: (part: HTMLElement) => void
  remove: (part: HTMLElement) => void
}

/** Context composed Card parts use to register with their nearest Card. */
export const cardPartRegistryContext = createContext<CardPartRegistry | undefined>(
  Symbol('nord-card-part-registry'),
)
